import React from 'react'
import moment from 'moment-timezone'
import AceHighwayShipmentApiUrls from "../../apiUrls/AceHighwayShipmentApiUrls"
import { constants } from 'cng-web-lib'
import TemplateSelectDialog from 'src/components/aciacehighway/TemplateSelectDialog'
import { useHistory } from 'react-router-dom'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import pathMap from 'src/paths/pathMap'
import ACEHwyInbondArrivalTranslationText from 'src/views/aceHwyInbondArrival/context/ACEHwyInbondArrivalTranslationText';

function TemplateSelectDialogWithOptionACEHWYManifest(props) {
  const {
    manifestDialog,
    setManifestDialog,
    showNotification,
    translatedTextsObject,
    setValue,
    reset,
    trigger
  } = props

  const {
    filter: { LIKE, EQUAL }
  } = constants

  const history = useHistory()
  const aceHwyInbondArrivalTranslationText = ACEHwyInbondArrivalTranslationText()

  function handleApplyShipment(template) {
    if (template) {
      const {
        headerId,
        tripNo,
        arrivalDate,
        firstExpectedCode,
        bondNumber,
        inbondArrived
      } = template

      var convArrivalDate = moment(arrivalDate).tz("Canada/Eastern").format('YYYY-MM-DD HH:mm');

      if (inbondArrived) {
        setValue('messageCode', '833' || '', { shouldDirty: true })
      } else {
        setValue('messageCode', '98' || '', { shouldDirty: true })
      }
      setValue('manifestID', headerId || '', { shouldDirty: true })
      setValue('tripNo', tripNo || '', { shouldDirty: true })
      setValue('etaFirstPortUS', convArrivalDate || '', { shouldDirty: true })
      setValue('firstPort', firstExpectedCode || '', { shouldDirty: true })
      setValue('inbond7512No', bondNumber || '', { shouldDirty: true })
      setValue('msgFunction', '64' || '', { shouldDirty: true })

      showNotification('success',aceHwyInbondArrivalTranslationText.inbondAppliedSuccessMsg)
      trigger()

    } else {
      reset()
    }
  }

  const columns = [
    {
      field: 'tripNo',
      sortKey: 'tripNo',
      title: aceHwyInbondArrivalTranslationText.tripNo,
      render: (data) => {
        var manifestUrl = `${pathMap.ACE_HIGHWAY_MANIFEST}/edit/${data.headerId}`

        return (<div style={{ 'text-decoration': 'underline', cursor: 'pointer' }} onClick={(event) => {
          event.stopPropagation()
          history.push(manifestUrl)
        }}>{data.tripNo}</div>)
      }
    },
    {
      field: 'arrivalDate',
      sortKey: 'arrivalDate',
      title: aceHwyInbondArrivalTranslationText.etaFirstPortUS,
      render: (data) =>
        data.arrivalDate &&
        moment(data.arrivalDate).tz("Canada/Eastern").format('D MMM YYYY, HH:mm')
    },
    {
      field: 'firstExpectedCode',
      sortKey: 'firstExpectedCode',
      title: aceHwyInbondArrivalTranslationText.firstPort
    },
    {
      field: 'bondNumber',
      sortKey: 'bondNumber',
      title: aceHwyInbondArrivalTranslationText.inbond7512No
    },
    {
      field: 'inBondDestination',
      sortKey: 'inBondDestination',
      title: aceHwyInbondArrivalTranslationText.inbondDestination
    },
    {
      field: 'inbondArrived',
      sortKey: 'inbondArrived',
      title: aceHwyInbondArrivalTranslationText.arrivalStatus,
      render: (data) => {
        return (<div style={{ 'text-decoration': 'underline', cursor: 'pointer' }} onClick={(event) => {
          event.stopPropagation()
          history.push(`${pathMap.ACE_HIGHWAY_MANIFEST}/edit/${data.headerId}`, { step: 4 })
        }}>{data.inbondArrived ? aceHwyInbondArrivalTranslationText.arrivalOfInbondNumber : aceHwyInbondArrivalTranslationText.notReceivedMessage}</div>)
      }
    },
    {
      field: 'inbondExported',
      sortKey: 'inbondExported',
      title: aceHwyInbondArrivalTranslationText.exportStatus,
      render: (data) => {
        return (<div style={{ 'text-decoration': 'underline', cursor: 'pointer' }} onClick={(event) => {
          event.stopPropagation()
          history.push(`${pathMap.ACE_HIGHWAY_MANIFEST}/edit/${data.headerId}`, { step: 4 })
        }}>{data.inbondExported ? aceHwyInbondArrivalTranslationText.exportOfInbondNumber : aceHwyInbondArrivalTranslationText.notReceivedMessage}</div>)
      }
    }
  ]

  const sortOptions = [
    {
      label: aceHwyInbondArrivalTranslationText.tripNo,
      value: 'tripNo'
    },
    {
      label: aceHwyInbondArrivalTranslationText.etaFirstPortUS,
      value: 'arrivalDate'
    },
    {
      label: aceHwyInbondArrivalTranslationText.firstPort,
      value: 'firstExpectedCode'
    },
    {
      label: aceHwyInbondArrivalTranslationText.inbond7512No,
      value: 'bondNumber'
    },
    {
      label: aceHwyInbondArrivalTranslationText.inbondDestination,
      value: 'inBondDestination'
    },
    {
      label: aceHwyInbondArrivalTranslationText.arrivalStatus,
      value: 'inbondArrived'
    },
    {
      label: aceHwyInbondArrivalTranslationText.exportStatus,
      value: 'inbondExported'
    }
  ]

  return (
    <TemplateSelectDialog
      columns={columns}
      defaultSorts={[{ field: 'createdDate', direction: 'DESC' }]}
      fetch={{ url: AceHighwayShipmentApiUrls.CUSTOM_SEARCH_INBOND }}
      fetchFilters={
        [
          { field: 'isInBondShipment', operator: EQUAL, value: true },
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
        ]
      }
      onApplyTemplate={handleApplyShipment}
      onClose={() => setManifestDialog(false)}
      open={manifestDialog}
      search={{ field: 'tripNo', operator: LIKE }}
      sortOptions={sortOptions}
      title={aceHwyInbondArrivalTranslationText.manifestTitle}
      isTable={true}
    />
  )
}

export default TemplateSelectDialogWithOptionACEHWYManifest
